<!--title -->
<app-modal-title
  [title]="'common.selectRequestId'|translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <form [formGroup]="requestDataForm">
    <div class="tw-w-full">
      <div class="tw-flex-center tw-flex-col">
        <!-- title -->
        <form-field
          [(value)]="requestId"
          class="tw-w-full"
          label="common.requestId"
          [control]="requestDataForm?.get('requestId')"
        >
        </form-field>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions class="tw-w-full">
  <div class="tw-w-full tw-flex tw-justify-end">
    <div
      class="tw-flex tw-justify-end tw-h-[70%] tw-w-full"
      style="max-width: 275px"
    >
      <!-- cancel btn -->
      <a
        mat-ripple
        class="btn tw-ml-[5px] ltr:tw-mr-[5px] tw-w-1/2 button-shadow tw-h-[70%]"
        [themeColor]="'cancel-btn'"
        (click)="onNoClick()"
      >
        {{'common.cancel'|translate}}
      </a>

      <!-- submit btn -->
      <button
        [type]="'button'"
        mat-ripple
        class="btn tw-w-full tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise tw-mb-1 tw-h-[70%]"
        [themeColor]="'btn'"
        [disabled]="getRequestId()==-1"
        [mat-dialog-close]="getRequestId()"
        cdkFocusInitial
      >
        <span> {{'common.submit'|translate}}</span>
      </button>
    </div>
  </div>
</div>
